import { createStore, applyMiddleware, Store } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';

import rootReducer from 'state';
import window from 'window';

const preloadedState = window.__PRELOADED_STATE__;
delete window.__PRELOADED_STATE__;

const compose =
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || composeWithDevTools;

export default (): Store => {
  const store = createStore(
    rootReducer,
    preloadedState,
    compose(applyMiddleware()),
  );

  return store;
};
